var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.754 20.485h5.3c1.201 0 2.61-.754 2.43-2.26s-.996-7.98-1.086-8.482-.366-2.067-2.35-2.067H9.043c-1.348 0-2.756.168-3.004 1.982-.247 1.815-.936 7.435-1.033 8.567s.947 2.26 2.089 2.26zm-2.75-12.973v-.461c0-.586.578-2.551 2.735-2.551s2.76 1.898 2.76 2.547v.465"
  })));
};
export default SvgBag;